(function () {
  'use strict';

  const SLIDER_SELECTOR = '.swiper-container';

  function initSlider(sliderEl) {
    if (!sliderEl || sliderEl.dataset.swiperInitialized === 'true') return;

    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not loaded yet — deferring init for', sliderEl);
      return;
    }

    const buttonGroup = sliderEl.closest('.product-button-group') ||
                        sliderEl.querySelector('.product-button-group') ||
                        sliderEl.parentElement && sliderEl.parentElement.querySelector('.product-button-group');

    const nextBtn = (buttonGroup && buttonGroup.querySelector('.swiper-button-next-1')) || sliderEl.querySelector('.swiper-button-next-1');
    const prevBtn = (buttonGroup && buttonGroup.querySelector('.swiper-button-prev-1')) || sliderEl.querySelector('.swiper-button-prev-1');
    const paginationEl = sliderEl.querySelector('.product-card-pagination');

    const config = {
      slidesPerView: 1,
      speed: 250,
      spaceBetween: 0
    };

    if (nextBtn || prevBtn) {
      config.navigation = {};
      if (nextBtn) config.navigation.nextEl = nextBtn;
      if (prevBtn) config.navigation.prevEl = prevBtn;
    }

    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    try {
      const instance = new Swiper(sliderEl, config);
      sliderEl._swiperInstance = instance;
      sliderEl.dataset.swiperInitialized = 'true';
    } catch (err) {
      console.error('Failed to initialize Swiper on', sliderEl, err);
    }
  }

  function destroySlider(sliderEl) {
    if (!sliderEl) return;
    const instance = sliderEl._swiperInstance;
    if (instance && typeof instance.destroy === 'function') {
      try {
        instance.destroy(true, true);
      } catch (err) {
        console.warn('Error destroying swiper instance', err);
      }
    }
    delete sliderEl._swiperInstance;
    if (sliderEl.dataset.swiperInitialized) delete sliderEl.dataset.swiperInitialized;
  }

  function initAllWithin(root = document) {
    if (typeof Swiper === 'undefined') {
      // Ensure we try again once the page fully loads (handle scripts loaded later).
      window.addEventListener('load', () => initAllWithin(root), { once: true });
      return;
    }
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  if (document.readyState !== 'loading') {
    initAllWithin(document);
  } else {
    document.addEventListener('DOMContentLoaded', () => initAllWithin(document), { once: true });
    window.addEventListener('load', () => initAllWithin(document), { once: true });
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target || document;
    initAllWithin(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target || document;
    if (!section) return;
    section.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
  });

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches && node.matches(SLIDER_SELECTOR)) {
          initSlider(node);
        } else if (node.querySelectorAll) {
          const nested = node.querySelectorAll(SLIDER_SELECTOR);
          if (nested.length) nested.forEach(initSlider);
        }
      }

      for (const node of m.removedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches && node.matches(SLIDER_SELECTOR)) {
          destroySlider(node);
        } else if (node.querySelectorAll) {
          const nested = node.querySelectorAll(SLIDER_SELECTOR);
          if (nested.length) nested.forEach(destroySlider);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.__initSwipers = initAllWithin;
  window.__destroySwipers = () => document.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
})();
